import { Type } from "class-transformer";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumber, IsOptional, IsString, MaxLength } from "class-validator";
import { QualityTypeEnum } from "@gtpl/shared-models/common-models";

export class QaqcFibreAnalysisDto {
    @ApiPropertyOptional()
    id: number;

    @ApiProperty()
    @IsString()
    
    @IsOptional()
    workOrderNo: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    lotNumber: string;

    @ApiProperty()
    @IsString()
    
    operation: string;

    @ApiProperty()
    @IsString()
    
    @MaxLength(100, { message: "Previous Operation Length Should be less than or Equal to 100" })
    prevOperation: string;

    @ApiProperty()
    
    @IsOptional()
    product: Number;

    @ApiProperty()
    @IsOptional()
    quality: QualityTypeEnum;

    @ApiPropertyOptional()
    @IsNumber()
    meanLength: number;

    @ApiPropertyOptional()
    @IsNumber()
    shortestFiber: number;

    @ApiPropertyOptional()
    @IsNumber()
    longestFiber: number;

    @ApiPropertyOptional()
    @IsNumber()
    shortFiberPercent: number;

    @ApiPropertyOptional()

    slub: any;

    @ApiProperty()
    
    quantity: any;

    @ApiProperty()
    testDate: any;
    
    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(50, { message: "Test Type Length Should be less than or Equal to 50" })
    testType: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(50, { message: "Analysis Type Length Should be less than or Equal to 50" })
    analysisType: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(500, { message: "Remarks Length Should be less than or Equal to 500" })
    remarks: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(50, { message: "Created User Length Should be less than or Equal to 50" })
    createdUser?: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(50, { message: "Updated User Length Should be less than or Equal to 50" })
    updatedUser?: string;

    @IsOptional()
    productionInventoryId?: number;
}

export class CreateQaqcFibreAnalysisDto extends QaqcFibreAnalysisDto {}

export class UpdateQaqcFibreAnalysisDto extends QaqcFibreAnalysisDto {
    @ApiProperty()
    @IsNotEmpty()
    id: number;
}
